// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let DateFns = require("date-fns");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RentalNeedLeaseAttributes_rentalNeedV5_graphql = require("../../../__generated__/RentalNeedLeaseAttributes_rentalNeedV5_graphql.bs.js");

let convertFragment = RentalNeedLeaseAttributes_rentalNeedV5_graphql.Internal.convertFragment;

function RentalNeedLeaseAttributes(props) {
  let match = RescriptRelay_Fragment.useFragment(RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment, props.rentalNeed);
  let availableFrom = match.availableFrom;
  let tmp;
  if (availableFrom !== undefined) {
    let from = DateFns.format(CalendarDate.toLocalDate(Primitive_option.valFromOption(availableFrom)), "M/d");
    tmp = " available on or before " + from;
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "lease requirements",
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "calendar",
          className: "text-zinc-600"
        }),
        JsxRuntime.jsxs("span", {
          children: [
            match.leaseLength.displayName + ` term`,
            tmp
          ],
          className: "text-zinc-700"
        })
      ],
      className: "flex flex-row items-start gap-2"
    })
  });
}

let make = RentalNeedLeaseAttributes;

exports.make = make;
/* IconV5 Not a pure module */
